import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import ActionBanner from 'js/components/ActionBanner';
import Footer from 'cccisd-footer';
import Modal from 'cccisd-modal';
import style from './style.css';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import { client } from 'cccisd-apollo';
import groupDeploymentQuery from '../../graphql/groupDeploymentQuery.graphql';

// import IconShoppingCart from 'cccisd-icons/cart';
import IconCog from 'cccisd-icons/cog';
import IconDashboard from 'cccisd-icons/meter';
import IconDataMgt from 'cccisd-icons/stats-dots';
import IconYouth from 'cccisd-icons/user';
import IconEvalCycle from 'cccisd-icons/checkbox-checked';
import IconOutcomes from 'cccisd-icons/stats-growth';
import IconReports from 'cccisd-icons/file-text3';
import IconResources from 'cccisd-icons/image2';
import IconData from 'cccisd-icons/download7';
import IconLogs from 'cccisd-icons/database2';
import IconMessage from 'cccisd-icons/envelop';

var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;
let deploymentHandle;
const isUber = ['uberadmin', 'guest'].includes(Fortress.user.acting.role.handle);
if (!isUber) {
    deploymentHandle = `${Fortress.user.acting.group.data_type}_${new Date().getFullYear()}`;
}

export default class FixedLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: style.wideContainer,
    };

    state = {
        deploymentProgress: null,
        showBanner: false,
    };

    componentDidMount = () => {
        if (!isUber) {
            this.checkComplete();
        }
    };

    checkComplete = async () => {
        await this.getGroupDeploymentProgress();
        this.setState({ showBanner: this.showBanner() });
    };

    showBanner = () => {
        if (isUber) {
            return false;
        }
        const hasManage = JSON.parse(Fortress.user.acting.role_data.permissions).includes('manage');

        if (!this.state.deploymentProgress && hasManage) {
            return true;
        }
        return false;
    };

    getGroupDeploymentProgress = async () => {
        if (['uberadmin', 'guest'].includes(Fortress.user.acting.role.handle)) {
            return false;
        }
        const response = await client.query({
            query: groupDeploymentQuery,
            variables: {
                deploymentHandle,
                handle: deploymentHandle,
                groupId: Fortress.user.acting.group.id,
            },
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        });

        await this.setState({
            deploymentProgress: response.data.roles.metricspawn.assignmentProgress.completed,
            groupPawn: response.data.roles.metricspawn.pawn,
        });
    };

    getFlowPropsVars = () => {
        const {
            groupDescriptionQuestion,
            dateEstablishedQuestion,
            populationFocusQuestion,
            positionsQuestion,
            turnoverRateQuestion,
            caseloadSizeQuestion,
            supervisionQuestion,
            parentPeerSupportQuestion,
            youthPeerSupportQuestion,
            trainingGroupUsedQuestion,
        } = Fortress.user.acting.group.type_data;
        return {
            groupDescriptionQuestion: groupDescriptionQuestion ? '1' : null,
            dateEstablishedQuestion: dateEstablishedQuestion ? '1' : null,
            populationFocusQuestion: populationFocusQuestion ? '1' : null,
            positionsQuestion: positionsQuestion ? '1' : null,
            turnoverRateQuestion: turnoverRateQuestion ? '1' : null,
            caseloadSizeQuestion: caseloadSizeQuestion ? '1' : null,
            supervisionQuestion: supervisionQuestion ? '1' : null,
            parentPeerSupportQuestion: parentPeerSupportQuestion ? '1' : null,
            youthPeerSupportQuestion: youthPeerSupportQuestion ? '1' : null,
            trainingGroupUsedQuestion: trainingGroupUsedQuestion ? '1' : null,
        };
    };

    getIcon = handle => {
        // based on the handle, return the appropriate icon
        switch (handle) {
            case 'manage':
                return IconCog;
            case 'dashboard':
                return IconDashboard;
            case 'youthRoster':
                return IconYouth;
            case 'evalCycle':
                return IconEvalCycle;
            case 'dataManagement':
                return IconDataMgt;
            case 'outcomes':
                return IconOutcomes;
            case 'reports':
                return IconReports;
            case 'resourceCenter':
                return IconResources;
            case 'viewData':
                return IconData;
            case 'appdefsLogs':
                return IconLogs;
            case 'resourceAdmin':
                return IconCog;
            case 'messageLogs':
                return IconMessage;
            default:
                return null;
        }
    };

    getNavItems = () => {
        if (Fortress.user.acting.role.handle === 'guest') {
            return;
        }
        const navs = AppDefs.navs;
        const permissions =
            Fortress.user.acting.role.handle !== 'uberadmin' && JSON.parse(Fortress.user.acting.role_data.permissions);

        // filter the navs based on the user's access permission
        // and return the object with the nav icon
        const permissionNavs = navs[0].nav
            .filter(nav => {
                return (
                    (permissions && permissions.includes(nav.handle)) ||
                    Fortress.user.acting.role.handle === 'uberadmin'
                );
            })
            .map(nav => {
                return {
                    ...nav,
                    icon: this.getIcon(nav.handle),
                };
            });

        return permissionNavs;
    };

    render() {
        const { groupPawn, showBanner } = this.state;
        const navs = this.getNavItems();

        return (
            <div className={style.body}>
                <div className={style.content}>
                    <Header
                        containerClassName="container-fluid"
                        wrapperClassName={style.wrapper}
                        logoClassName={style.logo}
                        secondaryNavLinks={navs}
                        showHomeAction={false}
                        showAlertAction={false}
                        showAdminAction={Fortress.hasRole('uberadmin')}
                        isDarkPrimaryNav
                        // showUserNav={!Fortress.hasRole('learner')}
                    />

                    {showBanner && groupPawn && (
                        <Modal
                            trigger={
                                <ActionBanner
                                    text="Click here to take the yearly group member survey!"
                                    actionText="Take Survey"
                                />
                            }
                            title="Yearly Group Survey"
                            beforeClose={this.checkComplete}
                        >
                            <div className={style.fixContainer}>
                                <DeploymentPlayer
                                    deploymentHandle={deploymentHandle}
                                    pawnId={groupPawn.pawnId}
                                    pawnHash={groupPawn.pawnHash}
                                    flowProps={{
                                        hidePlayButton: true,
                                        isPrintMode: false,
                                        variables: this.getFlowPropsVars(),
                                    }}
                                />{' '}
                            </div>
                        </Modal>
                    )}
                    <div className={this.props.className}>{this.props.children}</div>
                </div>
                <div className={style.footer}>
                    <Footer className={this.props.className} />
                </div>
            </div>
        );
    }
}
